import { volumeLine } from "./keywordModel";

// Free tier: the single keyword_volume line. Renders nothing without data.
export default function KeywordVolumeLine({ keywordVolume, lang }) {
  const v = volumeLine(keywordVolume, lang);
  if (!v) return null;
  return (
    <div className="mt-6 rounded-2xl border bg-card p-5 shadow-sm sm:p-6" data-testid="keyword-volume">
      <p className="text-base">{v.text}</p>
      <p className="mt-1 text-sm text-muted-foreground">{v.source}</p>
    </div>
  );
}
